import React, { useEffect } from 'react'
import './Core_vision.css'
import Common_Title_1 from '../../common/common_components/common_title_1/Common_Title_1'
import { AllTestimonials, OurCoreVision } from '../../../features/admin/common/Slice';
import { useDispatch, useSelector } from 'react-redux';
import { IDS } from '../../../utils/IDS';
import parse from "html-react-parser"

const Core_vision = () => {


    const dispatch = useDispatch();
    const core_vision = useSelector((state) => state.common.core_vision);


    useEffect(() => {
        dispatch(OurCoreVision());
    }, [dispatch])
    return (
        <>
            <section className="core_vision_section">
                <div className="container">
                    <div className='row justify-md-content-between justify-content-center'>
                        <div className='col-lg-6 col-md-7  mb-md-0 mb-3  order-md-1 order-2'>
                            <div className='contsec'>
                                <Common_Title_1 subText={core_vision?.name || "Our Core Vision"} />
                                <p className='content'>{parse(core_vision?.description || " ")} </p>
                            </div>
                        </div>
                        <div className='col-lg-5  col-md-5 col-6 order-md-2 order-1'>
                            <div className='img_holder'>

                            {/* <img className='guruimg' src={process.env.PUBLIC_URL + '/assets/images/gurudev/gurudev.png'} alt="guruimg" /> */}
                                <img className='guruimg' src={IDS.IMG_URL + core_vision?.Our_core_vision?.image || " "} alt="guruimg" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className="core_vision_section">
                <div className="container">
                    <div className='row justify-md-content-between justify-content-center'>
                        <div className='col-lg-6 col-md-7  mb-md-0 mb-3  order-md-1 order-2'>
                            <div className='contsec'>
                                <Common_Title_1 subText="Our Core Vision" />
                                <p className='content'>આધ્યાત્મિકતા, વિજ્ઞાન અને પ્રાણનો સમન્વય કરીને ઈશ્વરીય ચેતના સાથે
                                    જોડાઈ વાઇબ્રેશન ના માધ્યમથી તેનો અનુભવ કરી સમગ વિશ્વને જ્ઞાનમય,
                                    ધ્યાનમય પ્રાણમય બનાવીએ એ જ ૐ તપોવન આશ્રમ નો મૂળ હેતુ છે.</p>
                                <p className='content'>ॐ तपोवन का मूल उद्देश्य आध्यात्मिक, विज्ञान और प्राण का समन्वय कर के
                                    ईश्वरीय चेतना से जोड़ना और वाइब्रेशन (कंपन) के माध्यम से पूरे विश्व को
                                    ज्ञानमय, ध्यानमय और प्राणमय बनाना है।</p>
                                <p className='content'>The fundamental mission of Om Tapovan Ashram is to connect
                                    with divine consciousness by coordinating Spirituality, Science
                                    and Pran to make the entire world Gyanmay, Dhyanmay & Pranmay.</p>
                            </div>
                        </div>
                        <div className='col-lg-5  col-md-5 col-6 order-md-2 order-1'>
                        <div className='img_holder'>
                            <img className='guruimg' src={process.env.PUBLIC_URL + '/assets/images/gurudev/gurudev.png'} alt="guruimg" />
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </section> */}
        </>
    )
}

export default Core_vision